import { ValidationError } from "@/interface/interface";
import { IconLuChartColumn, IconLuTrendingUp } from "./icons";

export const PASSWORD_REGEX: RegExp = /^(?=.*[a-zA-Z])(?=.*\d)/
// export const API_BASE_URL: string = 'http://127.0.0.1:8000/v1';
// export const API_BASE_URL: string = 'https://irenafe.devkraft.in/v1';
export const API_BASE_URL: string = 'https://mandbe.irena.org/v1';
export const API_TIMEOUT: number = 100000;

export const BACKGROUND_IMAGE: string = 'https://i.ibb.co/FL7Pf8L2/bg-irena.png';
export const LOGO_IMAGE: string = 'https://i.ibb.co/SwvpHhft/logo2.png';

export const STATUS_LIST = [{ label: 'Draft', value: 'draft' }, { label: 'Submitted', value: 'submitted' }, { label: 'All', value: '' }];

export const SESSION_LIST = [{ label: 'Spring Council', value: 'Spring Council' }, { label: 'Fall Council', value: 'Fall Council' }, { label: 'Assembly', value: 'Assembly' }]

export const YEAR_LIST = [
  { label: '2025', value: '2025' },
  { label: '2026', value: '2026' },
  { label: '2027', value: '2027' },
  { label: '2028', value: '2028' },
  { label: '2029', value: '2029' },
  { label: '2030', value: '2030' }
]

export const YEAR_LIST_W_ALL = [
  { label: 'All', value: 'all' },
  { label: '2022', value: '2022' },
  { label: '2023', value: '2023' },
  { label: '2024', value: '2024' },
  { label: '2025', value: '2025' },
  { label: '2026', value: '2026' },
  { label: '2027', value: '2027' },
  { label: '2028', value: '2028' },
  { label: '2029', value: '2029' },
  { label: '2030', value: '2030' }
]

export const SESSION_LIST_W_ALL = [
  { label: 'All', value: 'all' },
  { label: 'Spring Council', value: 'Spring Council' },
  { label: 'Fall Council', value: 'Fall Council' },
  { label: 'Assembly', value: 'Assembly' }
]


export const validationErrors: ValidationError[] = [
  {
    row: "Header",
    column: "headers",
    cell: "A1",
    errorMessage: "Missing required columns: Survey_Date",
    currentValue: "-"
  },
  {
    row: "Header",
    column: "headers",
    cell: "A1",
    errorMessage: "Unexpected columns found: FIRST NAME",
    currentValue: "-"
  },
  {
    row: "1",
    column: "Survey_Date",
    cell: "A1",
    errorMessage: "Required field 'Survey_Date' is empty",
    currentValue: "-"
  },
  {
    row: "1",
    column: "Customer_ID",
    cell: "A1",
    errorMessage: "Required field 'Customer_ID' is empty",
    currentValue: "-"
  }
];

export const ViewChartsCards = [
  {
    title: "Performance Analytics",
    subtitle: "Key performance indicators and trends",
    icon: IconLuChartColumn,
    icon2: IconLuTrendingUp,
    title3: "3 charts available",
    key: "performance_analytics"
  },
  {
    title: "Data Visualization",
    subtitle: "Comprehensive data analysis view",
    icon: IconLuChartColumn,
    icon2: IconLuTrendingUp,
    title3: "2 charts available",
    key: "data_visualization"
  },
  {
    title: "Metrics Dashboard",
    subtitle: "Real-time metrics and monitoring",
    icon: IconLuChartColumn,
    icon2: IconLuTrendingUp,
    title3: "4 charts available",
    key: "metrics_dashboard"
  },
  {
    title: "Sales Analytics",
    subtitle: "Sales performance and revenue tracking",
    icon: IconLuChartColumn,
    icon2: IconLuTrendingUp,
    title3: "5 charts available",
    key: "sales_analytics"
  },
  {
    title: "Customer Insights",
    subtitle: "Customer behavior and satisfaction metrics",
    icon: IconLuChartColumn,
    icon2: IconLuTrendingUp,
    title3: "3 charts available",
    key: "customer_insights"
  }
]

export const DIVISION_LIST = [
  { label: 'Administration and Management Services', value: 'Administration and Management Services' },
  { label: 'Country Engagement and Partnerships', value: 'Country Engagement and Partnerships' },
  { label: 'IRENA Innovation and Technology Centre', value: 'IRENA Innovation and Technology Centre' },
  { label: 'Knowledge, Policy and Finance Centre', value: 'Knowledge, Policy and Finance Centre' },
  { label: 'Office of the Director General', value: 'Office of the Director General' },
  { label: 'Project Facilitation & Support', value: 'Project Facilitation & Support' }
]

export const ACTION_STATUS_LIST = [
  { label: 'Success', value: 'success' },
  { label: 'Error', value: 'error' }
]

export const ACTION_LIST = [
  { label: 'UPDATE_PROFILE', value: 'UPDATE_PROFILE' },
  { label: 'PASSWORD_CHANGED', value: 'PASSWORD_CHANGED' },
  { label: 'DOWNLOAD', value: 'DOWNLOAD' },
  // { label: 'ADD_TEMPLATE_(KPI)', value: 'ADD_TEMPLATE_(KPI)' },
  // { label: 'UPDATE_TEMPLATE_(KPI)', value: 'UPDATE_TEMPLATE_(KPI)' },
  // { label: 'DELETE_TEMPLATE_(KPI)', value: 'DELETE_TEMPLATE_(KPI)' },
  { label: 'ADD_USER', value: 'ADD_USER' },
  { label: 'UPDATE_USER_DETAIL', value: 'UPDATE_USER_DETAIL' },
  // { label: 'UPDATE_USER_STATUS', value: 'UPDATE_USER_STATUS' },
  // { label: 'CHANGE_USER_ROLE', value: 'CHANGE_USER_ROLE' },
  { label: 'DELETE_USER', value: 'DELETE_USER' },
  { label: 'VALIDATE_UPLOAD', value: 'VALIDATE_UPLOAD' }
]



export const CHART_TEMPLATE_LIST = [
  { label: 'Performance Analytics', value: 'performance_analytics' },
  { label: 'Data Visualization', value: 'data_visualization' },
  { label: 'Metrics Dashboard', value: 'metrics_dashboard' },
  { label: 'Sales Analytics', value: 'sales_analytics' },
  { label: 'Customer Insights', value: 'customer_insights' }
]


// export const YearToBiennium = (year: string) => {
//   if (year == "2025") {
//     return ["2022", "2023", "2024", "2025"]
//   }
//   if (year == "2026") {
//     return ["2024", "2025", "2026", "2027"]
//   }
//   if (year == "2027") {
//     return ["2024", "2025", "2026", "2027"]
//   }
//   if (year == "2028") {
//     return ["2026", "2027", "2028", "2029"]
//   }
//   if (year == "2029") {
//     return ["2026", "2027", "2028", "2029"]
//   }
//   if (year == "2030") {
//     return ["2028", "2029", "2030", "2031"]
//   }
// }

export const YearToBiennium = (year: string) => {
  const map: Record<string, string[]> = {
    "2025": ["2022", "2023", "2024", "2025"],
    "2026": ["2024", "2025", "2026", "2027"],
    "2027": ["2024", "2025", "2026", "2027"],
    "2028": ["2026", "2027", "2028", "2029"],
    "2029": ["2026", "2027", "2028", "2029"],
    "2030": ["2028", "2029", "2030", "2031"],
  };

  return {
    biennium: (map[year] ?? []).join(","),
  };
};

export const instructions = [
  {
    description: '1. Select the KPI type that matches your data',
  },
  {
    description: '2. Download the corresponding template',
  },
  {
    description: '3. Fill in your data following the exact column structure',
  },
  {
    description: '4. Upload the completed file for validation',
  },
  {
    description: '5. Fix any validation errors and re-upload if needed',
  },
]

const desiredOrder = [
  "Number of IRENA report produced 2022-2023",
  "Number of IRENA report produced 2024-2025",
  "Number of Knowledge products produced by type 2022-2023",
  "Number of Knowledge products produced by type 2024-2025",
  "Total Numbers of IRENA Reports and Partnership Reports produced by Topic 2022-2023",
  "Total Numbers of IRENA Reports and Partnership Reports produced by Topic 2024-2025",
  "Number of Translation by Language 2022-2023",
  "Number of Translation by Language 2024-2025"
];


const desiredHeight = [
  "Number of Knowledge products produced by type 2022-2023",
  "Number of Knowledge products produced by type 2024-2025",
]


export const sampleTableSchema = {
  type: 'table' as const,
  title: 'Sample Data Table',
  description: 'This is a dynamically generated table using Ant Design',
  headers: ['Category', 'Amount', 'Percentage'],
  data: [
    { Category: 'Technology', Amount: 6266, Percentage: 35.2 },
    { Category: 'Finance and Investment', Amount: 4533, Percentage: 25.4 },
    { Category: 'Outlook', Amount: 4099, Percentage: 23.0 },
    { Category: 'Data', Amount: 3121, Percentage: 17.5 },
    { Category: 'Total', Amount: 18019, Percentage: 100.0 }
  ],
  footer: 'Total'
};

export const chartBarData = [
  { "category": "Technology", "data_val": 6266, colorParam: "#C8DDED" },
  { "category": "Finance and Investment", "data_val": 4533, colorParam: "#C8DDED" },
  { "category": "Outlook", "data_val": 4099, colorParam: "#C8DDED" },
  { "category": "Data", "data_val": 3121, colorParam: "#C8DDED" }
]

export const chartBarData2 = {
  "id": "10013",
  "kpi_id": 10,
  "is_active": true,
  "type": "bar_chart",
  "title": "Number of projects receiving Project facilitation services by Thematic area (2022-2023)",
  "description": "Number of projects receiving Project facilitation services by Thematic area (2022-2023)",
  "legend_title": "",
  "kpi_name": "Project receiving facilatation service",
  "table_name": "project_receiving_facilataion_service",
  "leble_color": "#4277ab",
  "is_color_fixed": true,
  "sql_query": "SELECT\n    project_thematic_area AS category,\n    COUNT(*) AS data_val\nFROM public.project_receiving_facilataion_service\nWHERE year IN (2022, 2023)\n  AND project_thematic_area IS NOT NULL\nGROUP BY project_thematic_area\nORDER BY project_thematic_area DESC;\n",
  "data": [
    {
      "category": "Transportation: Biofuels for transport, and electric vehicle infrastructure.",
      "data_val": 8,
      "colorParam": "#4277ab"
    },
    {
      "category": "Industrial Use: Manufacturing and processing industries.",
      "data_val": 3,
      "colorParam": "#4277ab"
    },
    {
      "category": "Heating and Cooling: Solar thermal, geothermal heat pumps.",
      "data_val": 2,
      "colorParam": "#4277ab"
    },
    {
      "category": "Electricity Generation: Renewable power plants.",
      "data_val": 116,
      "colorParam": "#4277ab"
    },
    {
      "category": "Electricity Generation: Renewable power plants",
      "data_val": 2,
      "colorParam": "#4277ab"
    }
  ]
}

export const ChartGroupedBarData = [
  { "category": "Country\nengagement", "position": 0, "value": 8, "colorParam": "#C8DDED", "yearVal": "2022" },
  { "category": "Country\nengagement", "position": 1, "value": 10, "colorParam": "#83B8D9", "yearVal": "2023" },
  { "category": "Data", "position": 0, "value": 3, "colorParam": "#C8DDED", "yearVal": "2022" },
  { "category": "Data", "position": 1, "value": 3, "colorParam": "#83B8D9", "yearVal": "2023" },
  { "category": "Innovation", "position": 0, "value": 3, "colorParam": "#C8DDED", "yearVal": "2022" },
  { "category": "Innovation", "position": 1, "value": 2, "colorParam": "#83B8D9", "yearVal": "2023" },

  { "category": "Finance and investment", "position": 0, "value": 3, "colorParam": "#C8DDED", "yearVal": "2022" },

  { "category": "SmartTech", "position": 0, "value": 5, "colorParam": "#C8DDED", "yearVal": "2022" },
  { "category": "SmartTech", "position": 1, "value": 0, "colorParam": "#83B8D9", "yearVal": "2023" },

]

export const ChartStackedHorizontalBarData = [
  { "category": "Country engagement", "position": 0, "value": 8, "colorParam": "#C8DDED", "yearVal": "2022" },
  { "category": "Country engagement", "position": 0, "value": 10, "colorParam": "#83B8D9", "yearVal": "2023" },
  { "category": "Data", "position": 0, "value": 3, "colorParam": "#C8DDED", "yearVal": "2022" },
  { "category": "Data", "position": 0, "value": 3, "colorParam": "#83B8D9", "yearVal": "2023" },
  // { "category": "Finance and investment", "position": 0, "value": 3, "colorParam": "#C8DDED", "yearVal": "2022" },
  { "category": "Innovation", "position": 0, "value": 3, "colorParam": "#C8DDED", "yearVal": "2022" },
  { "category": "Innovation", "position": 0, "value": 2, "colorParam": "#83B8D9", "yearVal": "2023" }
]

export const ChartStackedHorizontalBarData2 = {
  "id": "7005",
  "kpi_id": 7,
  "is_active": true,
  "type": "stacked_horizontal_bar_chart",
  "title": "Actively Operating Partnership by Topic and Type (2022-2023)",
  "description": "Actively Operating Partnership by Topic and Type (2022-2023)",
  "xAxis": "topic",
  "yAxis": "count",
  "legend_title": "Type of Partnership",
  "table_name": "number_of_partnership",
  "color_key": "yearval",
  "sql_query": "SELECT\n    type_of_partnership AS yearVal,\n    topic AS category,\n    COUNT(*) AS value,\n    0 AS position\nFROM public.number_of_partnership\nWHERE year IN (2022, 2023)\n  AND type_of_partnership IS NOT NULL\n  AND topic IS NOT NULL\nGROUP BY type_of_partnership, topic\nORDER BY category DESC, value DESC;\n",
  "data": [
    {
      "category": "Technology",
      "position": 0,
      "value": 38,
      "colorParam": "#6caadb",
      "yearVal": "Bilateral partnerships"
    },
    {
      "category": "Technology",
      "position": 0,
      "value": 3,
      "colorParam": "#4e80a0",
      "yearVal": "Multilateral partnerships"
    },
    {
      "category": "Socio-economic impact",
      "position": 0,
      "value": 29,
      "colorParam": "#6caadb",
      "yearVal": "Bilateral partnerships"
    },
    {
      "category": "Socio-economic impact",
      "position": 1,
      "value": 3,
      "colorParam": "#4e80a0",
      "yearVal": "Multilateral partnerships"
    },
    {
      "category": "Project facilitation",
      "position": 0,
      "value": 14,
      "colorParam": "#6caadb",
      "yearVal": "Bilateral partnerships"
    },
    {
      "category": "Policy",
      "position": 0,
      "value": 40,
      "colorParam": "#6caadb",
      "yearVal": "Bilateral partnerships"
    },
    {
      "category": "Policy",
      "position": 1,
      "value": 8,
      "colorParam": "#4e80a0",
      "yearVal": "Multilateral partnerships"
    },
    {
      "category": "Planning",
      "position": 0,
      "value": 10,
      "colorParam": "#6caadb",
      "yearVal": "Bilateral partnerships"
    },
    {
      "category": "Outlook",
      "position": 0,
      "value": 15,
      "colorParam": "#6caadb",
      "yearVal": "Bilateral partnerships"
    },
    {
      "category": "Innovation",
      "position": 0,
      "value": 10,
      "colorParam": "#6caadb",
      "yearVal": "Bilateral partnerships"
    },
    {
      "category": "Innovation",
      "position": 1,
      "value": 2,
      "colorParam": "#4e80a0",
      "yearVal": "Multilateral partnerships"
    },
    {
      "category": "Finance and Investment",
      "position": 0,
      "value": 30,
      "colorParam": "#6caadb",
      "yearVal": "Bilateral partnerships"
    },
    {
      "category": "Finance and Investment",
      "position": 1,
      "value": 4,
      "colorParam": "#4e80a0",
      "yearVal": "Multilateral partnerships"
    },
    {
      "category": "Data",
      "position": 0,
      "value": 18,
      "colorParam": "#6caadb",
      "yearVal": "Bilateral partnerships"
    },
    {
      "category": "Country engagement ",
      "position": 0,
      "value": 34,
      "colorParam": "#6caadb",
      "yearVal": "Bilateral partnerships"
    },
    {
      "category": "Country engagement ",
      "position": 1,
      "value": 8,
      "colorParam": "#4e80a0",
      "yearVal": "Multilateral partnerships"
    }
  ]
}

export const chartStackedBarData = [
  { "x": "Data", "y": 45357, "c": 0, "legend_tag": "2022", "y0_color": "#83B8D9" },
  { "x": "Data", "y": 7729, "c": 1, "legend_tag": "2023", "y1_color": "#3E9FC1" },
  { "x": "Technology", "y": 27857, "c": 0, "legend_tag": "2022", "y0_color": "#83B8D9" },
  { "x": "Technology", "y": 0, "c": 1, "legend_tag": "2023", "y1_color": "#3E9FC1" },
  { "x": "Finance and Investment", "y": 9160, "c": 0, "legend_tag": "2022", "y0_color": "#83B8D9" },
  { "x": "Finance and Investment", "y": 0, "c": 1, "legend_tag": "2023", "y1_color": "#3E9FC1" },
  { "x": "Outlook", "y": 4099, "c": 0, "legend_tag": "2022", "y0_color": "#83B8D9" },
  { "x": "Outlook", "y": 0, "c": 1, "legend_tag": "2023", "y1_color": "#3E9FC1" },
  { "x": "Socio-economic impact", "y": 3823, "c": 0, "legend_tag": "2022", "y0_color": "#83B8D9" },
  { "x": "Socio-economic impact", "y": 48, "c": 1, "legend_tag": "2023", "y1_color": "#3E9FC1" },
  { "x": "Project facilitation", "y": 0, "c": 0, "legend_tag": "2022", "y0_color": "#83B8D9" },
  { "x": "Project facilitation", "y": 3150, "c": 1, "legend_tag": "2023", "y1_color": "#3E9FC1" },
]

export const chartStackedColumnBarData = {
  "id": "4009",
  "kpi_id": 4,
  "is_active": true,
  "type": "stacked_column_chart",
  "title": "Number of events organized / convened by IRENA by Type of events (2022-2023)",
  "description": "Number of events organized / convened by IRENA by Type of events (2022-2023)",
  "legend_title": "",
  "table_name": "events_organised",
  "color_key": "",
  "labelSchema": [
    "valnum",
    "value"
  ],
  "sql_query": "WITH event_years AS (\n    SELECT \n        type_of_event::text AS x,\n        SUM(CASE WHEN year = 2022 THEN 1 ELSE 0 END) AS events_2022,\n        SUM(CASE WHEN year = 2023 THEN 1 ELSE 0 END) AS events_2023\n    FROM public.events_organised\n    WHERE year IN (2022, 2023)\n    AND \"Governing body meeting\" = 'Spring Council' AND EXTRACT(YEAR FROM created_at) = '2025'\n    GROUP BY type_of_event\n)\nSELECT \n    x,\n    events_2022 AS y,\n    '2022' AS y0_color,\n    NULL AS y1_color\nFROM event_years\nWHERE events_2022 > 0 OR events_2023 > 0\n\nUNION ALL\n\nSELECT \n    x,\n    events_2023 AS y,\n    NULL AS y0_color,\n    '2023' AS y1_color\nFROM event_years\nWHERE events_2022 > 0 OR events_2023 > 0\n\nORDER BY x;\n",
  "data": [
    {
      "x": "Collaborative Framework meetings",
      "y": 17,
      "label_text": 17,
      "c": 0,
      "y0_color": "#c8dded"
    },
    {
      "x": "Collaborative Framework meetings",
      "y": 12,
      "label_text": 12,
      "c": 1,
      "y1_color": "#83b8d9"
    },
    {
      "x": "Conference",
      "y": 15,
      "label_text": 15,
      "c": 0,
      "y0_color": "#c8dded"
    },
    {
      "x": "Conference",
      "y": 26,
      "label_text": 26,
      "c": 1,
      "y1_color": "#83b8d9"
    },
    {
      "x": "Governing Body Meetings",
      "y": 18,
      "label_text": 18,
      "c": 0,
      "y0_color": "#c8dded"
    },
    {
      "x": "Governing Body Meetings",
      "y": 9,
      "label_text": 9,
      "c": 1,
      "y1_color": "#83b8d9"
    },
    {
      "x": "International and Regional Fora",
      "y": 26,
      "label_text": 26,
      "c": 0,
      "y0_color": "#c8dded"
    },
    {
      "x": "International and Regional Fora",
      "y": 18,
      "label_text": 18,
      "c": 1,
      "y1_color": "#83b8d9"
    },
    {
      "x": "Publication Launch",
      "y": 13,
      "label_text": 13,
      "c": 0,
      "y0_color": "#c8dded"
    },
    {
      "x": "Publication Launch",
      "y": 12,
      "label_text": 12,
      "c": 1,
      "y1_color": "#83b8d9"
    },
    {
      "x": "Side event (IRENA as main lead or co-lead)",
      "y": 60,
      "label_text": 60,
      "c": 0,
      "y0_color": "#c8dded"
    },
    {
      "x": "Side event (IRENA as main lead or co-lead)",
      "y": 70,
      "label_text": 70,
      "c": 1,
      "y1_color": "#83b8d9"
    },
    {
      "x": "Steering Committee, Advisory Group or Board Meetings",
      "y": 5,
      "label_text": 5,
      "c": 0,
      "y0_color": "#c8dded"
    },
    {
      "x": "Steering Committee, Advisory Group or Board Meetings",
      "y": 6,
      "label_text": 6,
      "c": 1,
      "y1_color": "#83b8d9"
    }
  ]
}

export const donutChartData = {
  "id": "1305",
  "kpi_id": 13,
  "is_active": true,
  "type": "pie",
  "title": "Number of member by Baseline biennium and Reporting cycle (2022-2023)",
  "description": "Number of member by Baseline biennium and Reporting cycle (2022-2023)",
  "legend_title": "Baseline biennium",
  "kpi_name": "Number of Members Participating in Governing body meetings",
  "table_name": "gbm_participation",
  "color_key": "color_value",
  "breaked_donut": true,
  "labelSchema": [
    "id",
    "valnum",
    "value"
  ],
  "custom_color_domain_key": "year",
  "data": [
    {
      "id": "12A",
      "value": 46.26,
      "valNum": 260,
      "label": "12A 260.0 (46.26%)",
      "colorValue": "#c8dded",
      "year": 2022
    },
    {
      "id": "13A",
      "value": 53.74,
      "valNum": 302,
      "label": "13A 302.0 (53.74%)",
      "colorValue": "#83b8d9",
      "year": 2023
    }
  ]
}

export const donutChartData2 = {
  "id": "7012",
  "kpi_id": 7,
  "is_active": true,
  "type": "pie",
  "title": "Total number of partners under Multilateral partnerships (2024-2025)",
  "description": "Total number of partners under Multilateral partnerships (2024-2025)",
  "legend_title": "",
  "kpi_name": "Number of partnership actively operating",
  "table_name": "number_of_partnership",
  "color_key": "color_target",
  "breaked_donut": true,
  "labelSchema": [
    "id",
    "valnum",
    "value"
  ],
  "data": [
    {
      "id": "Country engagement ",
      "value": 0,
      "valNum": 0,
      "label": "Country engagement  None (None%)",
      "colorValue": "#198274",
      "color_target": "Initiatives"
    },
    {
      "id": "Finance and Investment",
      "value": 0,
      "valNum": 0,
      "label": "Finance and Investment None (None%)",
      "colorValue": "#23b1c8",
      "color_target": "Cooperation platforms"
    },
    {
      "id": "Innovation",
      "value": 0,
      "valNum": 0,
      "label": "Innovation None (None%)",
      "colorValue": "#23b1c8",
      "color_target": "Cooperation platforms"
    },
    {
      "id": "Policy",
      "value": 0,
      "valNum": 0,
      "label": "Policy None (None%)",
      "colorValue": "#23b1c8",
      "color_target": "Cooperation platforms"
    },
    {
      "id": "Socio-economic impact",
      "value": 0,
      "valNum": 0,
      "label": "Socio-economic impact None (None%)",
      "colorValue": "#198274",
      "color_target": "Initiatives"
    },
    {
      "id": "Technology",
      "value": 0,
      "valNum": 0,
      "label": "Technology None (None%)",
      "colorValue": "#198274",
      "color_target": "Initiatives"
    }
  ]
}

export const chartTableData = {
  "id": "1",
  "kpi_id": 1,
  "is_active": true,
  "type": "table",
  "title": "IRENA reports produced by language translations (2022-2023)",
  "description": "IRENA reports produced by language translations (2022-2023)",
  "legend_title": "Language",
  "kpi_name": "Knowledge Product",
  "table_name": "IR1",
  "headers": [
    "Baseline biennium",
    "Number of IRENA reports produced"
  ],
  "data": [
    {
      "Baseline biennium": "2022",
      "Number of IRENA reports produced": 140
    },
    {
      "Baseline biennium": "2023",
      "Number of IRENA reports produced": 125
    },
    {
      "Baseline biennium": "Total",
      "Number of IRENA reports produced": 265
    }
  ]
}

export const pivotData1 = {
  "headers": [
    {
      "title": "Type of Publication",
      "data_key": "parent_key",
      "sequence": 1
    },
    {
      "title": "2022",
      "data_key": "topic_count_2022",
      "sequence": 2
    },
    {
      "title": "2023",
      "data_key": "topic_count_2023",
      "sequence": 3
    },
    {
      "title": "Number of knowledge products produced",
      "data_key": "parent_key_value",
      "sequence": 4
    }
  ],
  "data": [
    {
      "parent_key": "IRENA reports",
      "parent_key_value": 101,
      "child_data": [
        {
          "child_key": "Innovation",
          "child_key_value": 5,
          "topic_count_2022": 3,
          "topic_count_2023": 2
        },
        {
          "child_key": "Socio-economic impact",
          "child_key_value": 11,
          "topic_count_2022": 5,
          "topic_count_2023": 6
        },
        {
          "child_key": "Technology",
          "child_key_value": 22,
          "topic_count_2022": 14,
          "topic_count_2023": 8
        },
        {
          "child_key": "Outlook",
          "child_key_value": 10,
          "topic_count_2022": 4,
          "topic_count_2023": 6
        },
        {
          "child_key": "Data",
          "child_key_value": 6,
          "topic_count_2022": 3,
          "topic_count_2023": 3
        },
        {
          "child_key": "Planning",
          "child_key_value": 7,
          "topic_count_2022": 3,
          "topic_count_2023": 4
        },
        {
          "child_key": "Finance and Investment",
          "child_key_value": 3,
          "topic_count_2022": 0,
          "topic_count_2023": 3
        },
        {
          "child_key": "Project facilitation",
          "child_key_value": 3,
          "topic_count_2022": 1,
          "topic_count_2023": 2
        },
        {
          "child_key": "Policy",
          "child_key_value": 16,
          "topic_count_2022": 8,
          "topic_count_2023": 8
        },
        {
          "child_key": "Country engagement ",
          "child_key_value": 18,
          "topic_count_2022": 8,
          "topic_count_2023": 10
        }
      ]
    },
    {
      "parent_key": "Technical advisory and other knowledge products",
      "parent_key_value": 98,
      "child_data": [
        {
          "child_key": "Policy",
          "child_key_value": 1,
          "topic_count_2022": 0,
          "topic_count_2023": 1
        },
        {
          "child_key": "Technology",
          "child_key_value": 1,
          "topic_count_2022": 0,
          "topic_count_2023": 1
        },
        {
          "child_key": "Country engagement ",
          "child_key_value": 18,
          "topic_count_2022": 17,
          "topic_count_2023": 1
        },
        {
          "child_key": "Data",
          "child_key_value": 4,
          "topic_count_2022": 4,
          "topic_count_2023": 0
        },
        {
          "child_key": "Project facilitation",
          "child_key_value": 1,
          "topic_count_2022": 0,
          "topic_count_2023": 1
        },
        {
          "child_key": "Planning",
          "child_key_value": 5,
          "topic_count_2022": 3,
          "topic_count_2023": 2
        },
        {
          "child_key": "Documents",
          "child_key_value": 1,
          "topic_count_2022": 0,
          "topic_count_2023": 1
        },
        {
          "child_key": "Finance and Investment",
          "child_key_value": 1,
          "topic_count_2022": 1,
          "topic_count_2023": 0
        },
        {
          "child_key": "Outlook",
          "child_key_value": 1,
          "topic_count_2022": 1,
          "topic_count_2023": 0
        },
        {
          "child_key": "Partnerships",
          "child_key_value": 65,
          "topic_count_2022": 24,
          "topic_count_2023": 41
        }
      ]
    },
    {
      "parent_key": "Translations",
      "parent_key_value": 48,
      "child_data": [
        {
          "child_key": "Policy",
          "child_key_value": 6,
          "topic_count_2022": 4,
          "topic_count_2023": 2
        },
        {
          "child_key": "Country engagement ",
          "child_key_value": 2,
          "topic_count_2022": 2,
          "topic_count_2023": 0
        },
        {
          "child_key": "Project facilitation",
          "child_key_value": 1,
          "topic_count_2022": 0,
          "topic_count_2023": 1
        },
        {
          "child_key": "Outlook",
          "child_key_value": 10,
          "topic_count_2022": 10,
          "topic_count_2023": 0
        },
        {
          "child_key": "Innovation",
          "child_key_value": 3,
          "topic_count_2022": 1,
          "topic_count_2023": 2
        },
        {
          "child_key": "Socio-economic impact",
          "child_key_value": 1,
          "topic_count_2022": 0,
          "topic_count_2023": 1
        },
        {
          "child_key": "Technology",
          "child_key_value": 16,
          "topic_count_2022": 8,
          "topic_count_2023": 8
        },
        {
          "child_key": "Partnerships",
          "child_key_value": 7,
          "topic_count_2022": 6,
          "topic_count_2023": 1
        },
        {
          "child_key": "Planning",
          "child_key_value": 2,
          "topic_count_2022": 1,
          "topic_count_2023": 1
        }
      ]
    },
    {
      "parent_key": "Partnership reports",
      "parent_key_value": 14,
      "child_data": [
        {
          "child_key": "Partnerships",
          "child_key_value": 14,
          "topic_count_2022": 5,
          "topic_count_2023": 9
        }
      ]
    },
    {
      "parent_key": "Technical papers",
      "parent_key_value": 4,
      "child_data": [
        {
          "child_key": "Policy",
          "child_key_value": 2,
          "topic_count_2022": 2,
          "topic_count_2023": 0
        },
        {
          "child_key": "Technology",
          "child_key_value": 2,
          "topic_count_2022": 2,
          "topic_count_2023": 0
        }
      ]
    }
  ]
}

export const pivotData2 = {
  "id": "1005",
  "kpi_id": 1,
  "is_active": true,
  "type": "pivot_chart",
  "title": "Knowledge products by type and topic (2022-2023)",
  "description": "Knowledge products by type and topic (2022-2023)",
  "legend_title": "",
  "table_name": "events_organised",
  "headers": [
    {
      "title": "Type of Publication",
      "data_key": "parent_key",
      "sequence": 1
    },
    {
      "title": "2022",
      "data_key": "topic_count_2022",
      "sequence": 2
    },
    {
      "title": "2023",
      "data_key": "topic_count_2023",
      "sequence": 3
    },
    {
      "title": "Number of knowledge products produced",
      "data_key": "parent_key_value",
      "sequence": 2
    }
  ],
  "data": [
    {
      "parent_key": "IRENA reports",
      "parent_key_value": 101,
      "child_data": [
        {
          "child_key": "Innovation",
          "child_key_value": 5,
          "topic_count_2022": 3,
          "topic_count_2023": 2
        },
        {
          "child_key": "Socio-economic impact",
          "child_key_value": 11,
          "topic_count_2022": 5,
          "topic_count_2023": 6
        },
        {
          "child_key": "Technology",
          "child_key_value": 22,
          "topic_count_2022": 14,
          "topic_count_2023": 8
        },
        {
          "child_key": "Outlook",
          "child_key_value": 10,
          "topic_count_2022": 4,
          "topic_count_2023": 6
        },
        {
          "child_key": "Data",
          "child_key_value": 6,
          "topic_count_2022": 3,
          "topic_count_2023": 3
        },
        {
          "child_key": "Planning",
          "child_key_value": 7,
          "topic_count_2022": 3,
          "topic_count_2023": 4
        },
        {
          "child_key": "Finance and Investment",
          "child_key_value": 3,
          "topic_count_2022": 0,
          "topic_count_2023": 3
        },
        {
          "child_key": "Project facilitation",
          "child_key_value": 3,
          "topic_count_2022": 1,
          "topic_count_2023": 2
        },
        {
          "child_key": "Policy",
          "child_key_value": 16,
          "topic_count_2022": 8,
          "topic_count_2023": 8
        },
        {
          "child_key": "Country engagement ",
          "child_key_value": 18,
          "topic_count_2022": 8,
          "topic_count_2023": 10
        }
      ]
    },
    {
      "parent_key": "Technical advisory and other knowledge products",
      "parent_key_value": 98,
      "child_data": [
        {
          "child_key": "Policy",
          "child_key_value": 1,
          "topic_count_2022": 0,
          "topic_count_2023": 1
        },
        {
          "child_key": "Technology",
          "child_key_value": 1,
          "topic_count_2022": 0,
          "topic_count_2023": 1
        },
        {
          "child_key": "Country engagement ",
          "child_key_value": 18,
          "topic_count_2022": 17,
          "topic_count_2023": 1
        },
        {
          "child_key": "Data",
          "child_key_value": 4,
          "topic_count_2022": 4,
          "topic_count_2023": 0
        },
        {
          "child_key": "Project facilitation",
          "child_key_value": 1,
          "topic_count_2022": 0,
          "topic_count_2023": 1
        },
        {
          "child_key": "Planning",
          "child_key_value": 5,
          "topic_count_2022": 3,
          "topic_count_2023": 2
        },
        {
          "child_key": "Documents",
          "child_key_value": 1,
          "topic_count_2022": 0,
          "topic_count_2023": 1
        },
        {
          "child_key": "Finance and Investment",
          "child_key_value": 1,
          "topic_count_2022": 1,
          "topic_count_2023": 0
        },
        {
          "child_key": "Outlook",
          "child_key_value": 1,
          "topic_count_2022": 1,
          "topic_count_2023": 0
        },
        {
          "child_key": "Partnerships",
          "child_key_value": 65,
          "topic_count_2022": 24,
          "topic_count_2023": 41
        }
      ]
    },
    {
      "parent_key": "Translations",
      "parent_key_value": 48,
      "child_data": [
        {
          "child_key": "Policy",
          "child_key_value": 6,
          "topic_count_2022": 4,
          "topic_count_2023": 2
        },
        {
          "child_key": "Country engagement ",
          "child_key_value": 2,
          "topic_count_2022": 2,
          "topic_count_2023": 0
        },
        {
          "child_key": "Project facilitation",
          "child_key_value": 1,
          "topic_count_2022": 0,
          "topic_count_2023": 1
        },
        {
          "child_key": "Outlook",
          "child_key_value": 10,
          "topic_count_2022": 10,
          "topic_count_2023": 0
        },
        {
          "child_key": "Innovation",
          "child_key_value": 3,
          "topic_count_2022": 1,
          "topic_count_2023": 2
        },
        {
          "child_key": "Socio-economic impact",
          "child_key_value": 1,
          "topic_count_2022": 0,
          "topic_count_2023": 1
        },
        {
          "child_key": "Technology",
          "child_key_value": 16,
          "topic_count_2022": 8,
          "topic_count_2023": 8
        },
        {
          "child_key": "Partnerships",
          "child_key_value": 7,
          "topic_count_2022": 6,
          "topic_count_2023": 1
        },
        {
          "child_key": "Planning",
          "child_key_value": 2,
          "topic_count_2022": 1,
          "topic_count_2023": 1
        }
      ]
    },
    {
      "parent_key": "Partnership reports",
      "parent_key_value": 14,
      "child_data": [
        {
          "child_key": "Partnerships",
          "child_key_value": 14,
          "topic_count_2022": 5,
          "topic_count_2023": 9
        }
      ]
    },
    {
      "parent_key": "Technical papers",
      "parent_key_value": 4,
      "child_data": [
        {
          "child_key": "Policy",
          "child_key_value": 2,
          "topic_count_2022": 2,
          "topic_count_2023": 0
        },
        {
          "child_key": "Technology",
          "child_key_value": 2,
          "topic_count_2022": 2,
          "topic_count_2023": 0
        }
      ]
    }
  ]
}

export const pivotData3 = {
  "headers": [
    {
      "title": "Baseline biennium",
      "data_key": "parent_key",
      "sequence": 1
    },
    {
      "title": "Council Alternate",
      "data_key": "Council Alternate",
      "sequence": 2
    },
    {
      "title": "Council Member",
      "data_key": "Council Member",
      "sequence": 3
    },
    {
      "title": "Member",
      "data_key": "Member",
      "sequence": 4
    },
    {
      "title": "Observer states",
      "data_key": "Observer states",
      "sequence": 5
    },
    {
      "title": "States in Accession",
      "data_key": "States in Accession",
      "sequence": 6
    },
    {
      "title": "Total",
      "data_key": "Total",
      "sequence": 7
    }
  ],
  "data": [
    {
      "child_data": [
        {
          "Total": 105,
          "Member": 70,
          "child_key": "23C ",
          "Council Member": 19,
          "Observer states": 2,
          "Council Alternate": 8,
          "States in Accession": 6
        },
        {
          "Total": 100,
          "Member": 67,
          "child_key": "24C",
          "Council Member": 17,
          "Observer states": 2,
          "Council Alternate": 9,
          "States in Accession": 5
        }
      ],
      "parent_key": 2022,
      "parent_key_value": 205
    },
    {
      "child_data": [
        {
          "Total": 103,
          "Member": 68,
          "child_key": "27C",
          "Council Member": 20,
          "Observer states": 1,
          "Council Alternate": 11,
          "States in Accession": 3
        },
        {
          "Total": 95,
          "Member": 59,
          "child_key": "25C",
          "Council Member": 21,
          "Observer states": 2,
          "Council Alternate": 9,
          "States in Accession": 4
        },
        {
          "Total": 115,
          "Member": 80,
          "child_key": "28C",
          "Council Member": 18,
          "Observer states": 1,
          "Council Alternate": 12,
          "States in Accession": 4
        },
        {
          "Total": 102,
          "Member": 67,
          "child_key": "26C",
          "Council Member": 20,
          "Observer states": 2,
          "Council Alternate": 10,
          "States in Accession": 3
        }
      ],
      "parent_key": 2023,
      "parent_key_value": 415
    }
  ]
}


